module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAv0lEQVQ4jZXUsW1CMRAA0BeL8rMRPfr0YRlSBjaAzBDo+QzARmGANEb6Mj4LX3k+P53uZH/8HE9L/OKAu75YYYftAhesc3LTga0wYcA54RsPLHHNBT3IA/uUOxg7sBIZcU/58F2sikCaFZXYVGAhUkIlNsywJgKLSvtP7HlxyvkQqXUUddZEWlB3RFA5k3Jmb0G1wdYW0ISi7UTbrEJz5M/rYJtYCpDo8YZY6kCaWMJXBxJhu4TPrPb8RXPshu0/BdBYHWvcTq8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/close.png
// module id = 361
// module chunks = 1